import React, { Component } from "react";
// import { Layout, Menu, Breadcrumb } from "antd";
// import {
//   UserOutlined,
//   LaptopOutlined,
//   NotificationOutlined,
// } from "@ant-design/icons";
 import SearchIncidents from "../images/searchIncidents.svg";
import Config from "../../config";
import { TicketTableUpdate } from "../../store/broadcaster/BroadcastRegister";
// const { SubMenu } = Menu;
// const { Header, Content, Sider } = Layout;

class TicketSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //   IncidentCountForMirraClaims: "",
    //   // IncidentCountForUHPMAT: "",
    //   IncidentCountForUHPG: "",
    //   IncidentCountForMirraEscalations: "",
    //   IncidentCountForInquiry: "",
    //   IncidentCountForCMSCalls: "",
    //   IncidentCountForMirraEnrollment: "",
    //   IncidentCountForUHPClaims: "",
    //   IncidentCountForMirraFollowUp: "",
    //   IncidentCountForMirraCorrespondence: "",
    //   MyIncidentCount: 0,
     // DepartmentQueue: [],
     Queues: [],
     Queuesdata: []
    };
    window.addEventListener("apiCallSuccess", this.callApi);
    TicketTableUpdate.subscribe(() => {
      this.callApi();
    });
  }

  callApi = () => {
    fetch(Config.Ticket + "/GetTickets", {
        method: "POST",
        headers: {
          Authorization: sessionStorage.getItem("access_token"),
          Accept: "application/json",
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          TenantID: sessionStorage.getItem("Tanent"),
          // "TenantID": 100,
          CreatedDate: null,
          TicketID: null,
          TicketType: null,
          CreatedFor: null,
          CreatedForID: null,
          CreatedBy: null,
          Status: null,
          NpiDetails: sessionStorage.getItem("npivalue") !== null ? JSON.parse(
            sessionStorage.getItem("npivalue")
          ) : [],
          TaxDetails: sessionStorage.getItem("taxid") !== null ? JSON.parse(
            sessionStorage.getItem("taxid")
          ) : [],
          TAXIDNPIMapping: sessionStorage.getItem("taxidNpiMapping") !== null ? JSON.parse(
            sessionStorage.getItem("taxidNpiMapping")
          ) : [],
        // TAXIDNPIMapping: [],
          Roles: sessionStorage.getItem("rolename").split(','),
          QueueID: null,
          SortTerm: null,
          IsAscending: true,
          PageNumber: 1,
          PageSize: 300,
          IsActive: true,
        }),
      })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
            Queues: result.Queues,
        //   DepartmentQueue: result.DepartmentQueue,
        //   MyIncidentCount: result.MyIncidentsCount,
        });
     //   console.log("Queues",this.state.Queues)
     this.updateRender();
      })
      .catch((e) => {
      });
  };
  updateRender = () => {
    // Force update the component to trigger a re-render
    this.forceUpdate();
  };

  componentDidMount() {
    return () => {
      window.removeEventListener("apiCallSuccess", this.callApi);
    };
  }

  render() {
   // console.log("Shiva",this.props),
 //   console.log("daataa@2",this.Queuesdata);
    return (
    //   <div>Hii</div>
      <div>
        {/* <div
          style={{
            backgroundColor: "white",
            fontSize: "1.5em",
            fontWeight: "600",
            padding: "6px 6px 6px 14px",
            boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)",
            borderRadius: "5px",
          }}
        >
          Incident
          <br />
          Queues
        </div> */}

        <div
          mode="inline"
          theme="light"
          style={{
            borderRight: 0,
            fontWeight: 600,
            marginTop: "2px",
            backgroundColor: "white",
            boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)",
          }}
        >
          <p
            style={{
              textAlign: "left",
              padding: "10px 10px 10px 10px",
              borderBottom: "1.5px solid rgba(0,0,0,.06)",
              marginBottom: "0px",
            }}
           onClick={() => this.props.sidebarClick()}
            className={
              this.props.sidebarActiveKey === null || this.props.sidebarActiveKey === undefined
                ? "details-tab-sidebar-queues sidebar"
                : "simple-button sidebar"
            }
          >
            Search <br/> Ticket
            <p
              style={{
                display: "inline-block",
                float: "right",
                marginTop: "-12px",
                marginRight: "2px",
                backgroundColor: "#4083F2",
                borderRadius: "25px",

                width: "25px",
                padding: "4px",
                textAlign: "center",
                height: "25px",
              }}
            >
              <img
                src={SearchIncidents}
                alt="Search Icon"
                style={{
                  display: "inline-block",
                  float: "right",
                  marginTop: "-11px",
                  marginRight: "-18px",

                  borderRadius: "25px",

                  width: "46px",
                  padding: "4px",
                  textAlign: "center",
                  height: "46px",
                }}
              ></img>
            </p>
          </p>

          {this.state.Queues.map((items, index) => {
            let keys = Object.values(items);
            return (
              <p
                style={{
                  textAlign: "left",
                  padding: "10px 10px 10px 10px",
                  borderBottom: "1.5px solid rgba(0,0,0,.06)",
                  marginBottom: "0px",
                }}
                onClick={() => this.props.sidebarClick(keys[0])}
                className={
                  this.props.sidebarActiveKey === keys[0]
                    ? "details-tab-sidebar-queues sidebar"
                    : "simple-button sidebar"
                }
              >
                <div style={{ width: "80%", display: "inline-block" }}>
                  {keys[1]}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "inline-block",
                    verticalAlign: "middle",
                    textAlign: "right",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "#4083F2",
                      borderRadius: "25px",
                      color: "#ffffff",
                      fontWeight: "500",
                      padding: "4px",
                    }}
                  >
                    {keys[2] < 10 ? "0" + keys[2] : keys[2]}
                  </span>
                </div>
              </p>
            );
          })}
        </div>
      </div>
    );
  }
}

export default TicketSidebar;
